import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=052551d8&"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=ts&"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports